import ExpandedSection from './ExpandedSection';
import './labResultsTextSection.css';

type LabResultsTextSectionProps = {
  chevronSrc: string;
  children: React.ReactNode;
  title?: string;
};

export default function LabResultsTextSection({
  chevronSrc,
  children,
  title = 'Lab Results',
}: LabResultsTextSectionProps) {
  return (
    <ExpandedSection title={title} chevronSrc={chevronSrc}>
      {children}
    </ExpandedSection>
  );
}
